module.exports = __webpack_public_path__ + "img/klarna-sofort.380722e0.png";